/**
 * SlideshowFilters — тонировка слайда одной строкой `ctx.filter`.
 *
 * Настольные конкуренты продают это как «фильтры обработки фото» (сепия,
 * ч/б, винтаж, HDR). В Canvas это буквально одна CSS-строка на контексте, то
 * есть функция, которой у нас не было не по цене, а потому что её никто не
 * завёл.
 *
 * Два обязательства перед компоновщиком:
 *   • чистая функция от ключа — превью и экспорт получают одну и ту же строку;
 *   • строка — только из функций цвета (grayscale, sepia, saturate, hue-rotate,
 *     brightness, contrast): у Safari до 18 `ctx.filter` НЕТ, и там её считает
 *     по пикселям CanvasCssFilter (public/js/canvas-css-filter.js). До
 *     27.09.2026 здесь стояло «в старых WebKit молча остаётся 'none'» — это
 *     было неверно дважды: значение читалось обратно (присваивание создаёт
 *     обычное свойство), а тонировки не было ни в превью, ни в файле. blur()
 *     и drop-shadow() сюда не добавлять — их пиксельного пути нет.
 */
(function () {
    'use strict';

    // Порядок = порядок в интерфейсе. Значения подобраны так, чтобы на
    // портретах кожа не уходила в зелёный (главная болезнь наивной сепии) и
    // чтобы «Ярко» не выжигало белое платье — на свадебных фото это первое,
    // что ломается.
    const FILTERS = [
        { key: 'none',    css: '' },
        { key: 'warm',    css: 'saturate(1.12) sepia(0.16) brightness(1.03)' },
        { key: 'cool',    css: 'saturate(1.06) hue-rotate(-8deg) brightness(1.02) contrast(1.04)' },
        { key: 'vivid',   css: 'saturate(1.35) contrast(1.12)' },
        { key: 'soft',    css: 'saturate(0.92) brightness(1.06) contrast(0.94)' },
        // ⚠️ Сепия обязана начинаться с grayscale. Замерено 2026-08-31:
        // `sepia(0.72)` без обесцвечивания оставляет насыщенный бирюзовый
        // ЗЕЛЁНЫМ (31,112,142 → 96,111,100) — матрица sepia() не убирает
        // исходный цвет, а подмешивает к нему. На пёстрых кадрах это читается
        // как «фильтр не сработал», а не как сепия.
        { key: 'sepia',   css: 'grayscale(1) sepia(0.92) saturate(1.5) contrast(1.05)' },
        { key: 'vintage', css: 'grayscale(0.55) sepia(0.6) saturate(1.05) contrast(1.12) brightness(1.04)' },
        { key: 'bw',      css: 'grayscale(1) contrast(1.06)' },
        { key: 'noir',    css: 'grayscale(1) contrast(1.34) brightness(0.96)' },
    ];

    const BY_KEY = {};
    FILTERS.forEach(function (f) { BY_KEY[f.key] = f; });

    function css(key) {
        const f = BY_KEY[key];
        return f && f.css ? f.css : '';
    }

    window.SlideshowFilters = {
        FILTERS: FILTERS,
        KEYS: FILTERS.map(function (f) { return f.key; }),
        css: css,
    };
})();
